import ff from './ff';

export default class i10d { // 設備情報

static d_defs = {

/*
  DROP TABLE t_i10r;
  CREATE TABLE t_i10r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i10rb21f INTEGER,
    i10rb51f INTEGER,
    i10rc11s TEXT,
    i10rc31s TEXT,
    i10rt11i INTEGER,
    i10ri11i INTEGER,
    i10ri21i INTEGER,
    i10ri11m BIGINT,
    i10rt21i INTEGER,
    i10rcx1i INTEGER,
    i10rcy1t TEXT,
    i10rcy1f INTEGER,
    i10rcz1i INTEGER
  );
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '1', '会議室1', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '2', '会議室2', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '3', '会議室3A', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '4', '会議室3B', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '5', '工芸室', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '6', '音楽室', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '7', '和室１', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '8', '和室２', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '9', '広間', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '10', '集会ホールA', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '11', '集会ホールB', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '12', '集会ホールC', 200, 1, 2, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '13', 'レクホール', 200, 1, 1, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 2, '14', '料理室', 200, 1, 4, 690, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '15', '駐車場', 400, 4, 1, 300, 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i10r (_vsn, _ltt, i10rb21f, i10rb51f, i10rc11s, i10rc31s, i10rt11i, i10ri11i, i10ri21i, i10ri11m, i10rcx1i, i10rcy1t, i10rcy1f, i10rcz1i)
  VALUES (1, 1, 1, 1, '16', 'ホワイトボード', 400, 4, 1, 100, 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i10r SET _fst = _key;
*/

  i10r: {
    0: {
      pfx: '室・設備情報親',
      b_vsn: true,
/*
      d_insDats: {
        b_upd: false,
        b_new: true,
        b_dlt: false,
        d_flds: {
          i10rb21f: -1,
          i10rb51f: -1,
          i10rc11s: '',
          i10rc31s: '',
          i10rt11i: -1,
          i10ri11i:  1,
          i10ri11m:  0,
        },
      },
*/
      d_insFlds: {
        i10rb21f: -1,
        i10rb51f: -1,
        i10rc11s: '',
        i10rc31s: '',
        i10rt11i: -1,
        i10ri11i:  1,
        i10ri11m:  0,
      },
      dd_fldDefss: {
        i10rb21f: { 
          pfx: 'c20m_fst',
          type: 'Inp',
        },
        i10rb51f: { // i11r_fst
          pfx: '時間帯区分', 
          type: 'Pck',
          n_col: 7,
        },
        i10rc11s: {
          pfx: 'ID',
          type: 'Inp',
          n_col: 4,
        },
        i10rc31s: {
          pfx: '室・設備名',
          type: 'Inp',
          n_col: 15,
        },
        i10rt11i: {
          pfx: '種別',
          type: 'Pck',
          n_col: 6,
          ld_iss: [
            { key: -1, pfx: ' ', },
            { key: 200, pfx: '室', }, // 室
            { key: 400, pfx: '設備', }, // 室と同時に予約
          ]
        },
        i10ri11i: {
          pfx: '保有数', // 0:無制限
          type: 'Inp',
          n_col: 6,
        },
        i10ri21i: {
          pfx: '連続コマ数', // 0:無制限
          type: 'Inp',
          n_col: 6,
          bsd: 'コマ',
        },
        i10ri11m: {
          pfx: '利用料',
          type: 'Inp',
          n_col: 6,
          bsd: '円',
        },
        i10rt21i: {
          pfx: '複数予約',
          type: 'Pck',
          ini: 10,
          n_col: 6,
          ld_iss: [
            { key: -1, pfx: ' ', },
            { key: 0, pfx: '不可', },
            { key: 10, pfx: '可', },
          ]
        },
      },
    },
  },

};

};
